import { Fragment } from 'preact'

/* eslint-disable import/order */
import * as embedBlockTransformer from './blocks/embed'
import * as galleryBlockTransformer from './blocks/gallery'
import * as imageBlockTransformer from './blocks/image'

import * as captionTransformer from './caption'
import * as preCodeTransformer from './pre-code'
import * as codeTransformer from './code'
import * as preTransformer from './pre'
import * as galleryTransformer from './gallery'
import * as asideTransformer from './aside'
import * as titleListTransformer from './title-list'
import * as lightboxTransformer from './lightbox'
import * as audioTransformer from './audio'
import * as tableTransformer from './table'
import * as iframeTransformer from './iframe'
import * as imgTransformer from './img'
import * as linksTransformer from './links'
import * as blockQuoteTransformer from './blockquote'
import * as dropCapTransformer from './drop-cap'
import * as paragraphTransformer from './paragraph'
import * as headingTransformer from './heading'
/* eslint-enable import/order */

const TRANSFORMERS = [
  embedBlockTransformer,
  galleryBlockTransformer,
  imageBlockTransformer,
  captionTransformer,
  preCodeTransformer,
  codeTransformer,
  preTransformer,
  iframeTransformer,
  galleryTransformer,
  asideTransformer,
  titleListTransformer,
  lightboxTransformer,
  audioTransformer,
  tableTransformer,
  imgTransformer,
  linksTransformer,
  blockQuoteTransformer,
  dropCapTransformer,
  paragraphTransformer,
  headingTransformer,
]

export const COMPONENTS = TRANSFORMERS
  .reduce(
    (memo, t) => ({ ...memo, ...(t.COMPONENTS || {}) }),
    { Fragment },
  )

export default TRANSFORMERS
